export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/balloon.af3b4259-94678d.svg";